import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { text } from 'chaoskit/src/assets/styles/utility'
import { greenTeal } from 'chaoskit/src/assets/styles/utility/gradient'

import ButtonLink from './ButtonLink'

export const getMonthFromDate = (date) =>
  date.toLocaleString('en', {
    timeZone: 'UTC',
    month: 'short',
  })

export const getDayFromDate = (date) =>
  date.toLocaleString('en', {
    timeZone: 'UTC',
    day: '2-digit',
  })

const DateActionCard = ({ date, time, title, actionProps, actionLabel }) => {
  const theme = useTheme()

  const dateInstance = new Date(date)

  return (
    <div
      css={{
        display: 'grid',
        gridTemplateColumns: 'min-content 2px 1fr',
        gap: theme.space.large,
        background: theme.color.light.base,
        border: theme.border.base,
        borderRadius: theme.borderRadius.base,
        boxShadow: theme.boxShadow.large,
        padding: theme.space.large,
      }}
    >
      <div css={[text.heading(theme), { lineHeight: 1, textAlign: 'center' }]}>
        <div
          css={{
            fontSize: theme.fontSize.xlarge,
            textTransform: 'uppercase',
            letterSpacing: theme.letterSpacing.base,
          }}
        >
          {getMonthFromDate(dateInstance)}
        </div>
        <div css={{ fontSize: theme.fontSize.h1 }}>
          {getDayFromDate(dateInstance)}
        </div>
      </div>
      <div css={[greenTeal(theme)]} />
      <div>
        {title && <h3 css={{ marginBottom: 0 }}>{title}</h3>}
        <div
          css={{
            fontWeight: theme.fontWeight.bold,
            fontSize: theme.fontSize.large,
            color: theme.fontColor.muted,
            textTransform: 'uppercase',
            marginBottom: theme.space.small,
          }}
        >
          {time}
        </div>
        <ButtonLink type="primary" {...actionProps}>
          {actionLabel}
        </ButtonLink>
      </div>
    </div>
  )
}

DateActionCard.propTypes = {
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  title: PropTypes.string,
  actionProps: PropTypes.object,
  actionLabel: PropTypes.string.isRequired,
}

export default DateActionCard
